import React from 'react';

import DrawDateCounter, { Props as DrawDateCounterProps } from './DrawDateCounter';

const DrawDateCounterLoader: React.FC<DrawDateCounterProps> = (props) => {
    return <DrawDateCounter {...props} />;
};

export default DrawDateCounterLoader;
